var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4753 29.7729L56.8826 36.2377L64.4277 28.625L51.9242 15.9985C51.0334 14.3092 49.6059 13.0098 47.9209 12.3167C45.2485 11.223 42.3936 11.4829 40.0968 12.9881C37.7893 11.4829 34.9451 11.223 32.2727 12.3167C30.4696 13.0531 28.9993 14.4608 28.1192 16.2693L15.562 28.9282L22.506 35.9345L29.5144 28.8632C29.8471 33.5413 29.1925 38.2844 27.5933 42.6809L20.7781 61.4148C20.7781 61.4148 28.9993 66.6668 40.0968 66.6668C51.0012 66.6668 59.4155 61.4148 59.4155 61.4148L52.4715 42.3344C51.0119 38.3277 50.3357 34.0286 50.4753 29.7729ZM22.506 33.4222L18.052 28.9282L29.5681 17.298L29.6325 17.1572C30.3086 15.6845 31.4785 14.5475 32.9274 13.9519C35.2457 13.0098 37.6605 13.313 39.5602 14.764L40.0861 15.1647L40.612 14.764C42.5117 13.313 44.9372 12.9989 47.2447 13.9519C48.5863 14.5042 49.7132 15.5546 50.4109 16.9298L61.9377 28.6142L56.8719 33.7254L49.0049 25.7878C49.0049 25.7878 48.758 25.8961 48.758 32.9132H31.3068C31.3068 25.0406 30.8775 24.9757 30.8775 24.9757L22.506 33.4222ZM40.0968 64.8801C34.1295 64.8801 28.2158 63.3965 22.9461 60.581L29.2354 43.2873C30.2443 40.5259 30.8775 37.6238 31.1673 34.6892H48.919C49.2195 37.5047 49.8528 40.2877 50.8187 42.9408L57.2368 60.5918C51.9671 63.3965 46.0641 64.8801 40.0968 64.8801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.5238,
    height: 55.2381,
    fill: "white",
    transform: "translate(15.238 11.4286)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDress);
export default __webpack_public_path__ + "static/media/icon-dress.e15143fd.svg";
export { ForwardRef as ReactComponent };